var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gantt-chart",class:{ 'chart-gantt--highlight-today': _vm.showToday }})}
var staticRenderFns = []

export { render, staticRenderFns }